import React, { useEffect } from 'react';
import { Field, reduxForm } from 'redux-form';
import t, { partial } from '../../util/translation/translation';
import validateWebsiteComponentForm from './validateWebsiteComponentForm';
import renderField from '../../shared/components/custom/Field';

const SectionLabelComponentForm = ({
  component,
  handleSubmit,
  initialize,
  onClose,
}) => {
  const s = partial('shared');

  useEffect(() => {
    initialize({
      title: component?.value || '',
    });
  }, [component]);

  return (
    <form className="form" onSubmit={handleSubmit}>
      <div className="qm-body">
        <div className="form__form-group mb-0">
          <span className="form-header">{t('appLayout.headingField')}</span>
          <Field
            name="title"
            component={renderField}
            placeholder={s('title')}
          />
        </div>
      </div>
      <div className="qm-footer">
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm mb-0"
          onClick={onClose}
        >
          {t('appLayout.cancel')}
        </button>
        <button type="submit" className="btn btn-primary btn-sm mb-0">
          {component?.value ? s('update') : s('create')}
        </button>
      </div>
    </form>
  );
};

const reduxF = reduxForm({
  form: 'section_label_component_form',
  validate: validateWebsiteComponentForm,
});

export default reduxF(SectionLabelComponentForm);
